import React from 'react'
import { buildActions } from './actionhelpers'
import { sh, buildState } from './statehelpers'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { SetValue, ClearValue, AppendArrayValue, UpdateArrayValue } from './Actions/AppStateActions'
import { ClearUser, ClearSettings, ClearAccount } from './Actions/CurrentSessionActions'
import { CloseDrawer } from './Actions/DrawerActions'
import { sendToURL } from './Actions/ReduxRouterActions'
import { ShowErrorDispatch, ShowInfoDispatch, ShowWarningDispatch } from './Actions/ShowNotificationActions'
import { store } from './store'
import axios from 'axios'
import { Storage } from 'common-tools/StorageHelper'
import _ from 'common-tools/LodashHelper'
import { log, BuildMessageBusEvents, SendDrawBusMessage } from 'common-tools/index'
import { TimeSettings } from 'common-tools/SessionTimerHelper/TimerSettings'

export { compose } from 'redux'
export { ah } from './actionhelpers'
export { sh } from './statehelpers'
export { buildPropTypes, pt } from './proptypehelpers'

export const WithPropsWrapper = injectedProps => WrappedComponent => {
  const HasProps = props => <WrappedComponent {...injectedProps} {...props} />
  return HasProps
}

export const ReduxWrapper = (states = [], actions = []) => {
  return connect(
    buildState(states),
    buildActions(actions)
  )
}

const uuidv4 = require('uuid/v4')
const ShowError = ShowErrorDispatch()
const ShowInfo = ShowInfoDispatch()
const ShowWarning = ShowWarningDispatch()
export const QueryWrapperEvents = BuildMessageBusEvents('QueryWrapper', ['ServerTimeoutWarning'])

class ServerQueryTimer {
  constructor () {
    this.currentTimer = undefined
  }

  onTimeOut = () => {
    console.log('im calling timeout')
    SendDrawBusMessage(QueryWrapperEvents.NewServerTimeoutWarning())
  }
  // QueryWrapperEvents.NewServerTimeoutWarning()
  extendTimer = () => {
    if (this.currentTimer) {
      clearTimeout(this.currentTimer)
    }
    this.currentTimer = setTimeout(this.onTimeOut, TimeSettings.DataHelperTimer)
  }

  cancelTimer = () => {
    if (this.currentTimer) {
      clearTimeout(this.currentTimer)
    }
  }
}

const queryWrapperTimer = new ServerQueryTimer()

const CancelToken = axios.CancelToken

export function QueryWrapper (options) {
  let queryWrapper = (opts) => {
    return (WrappedComponent) => {
      opts = _.merge({ actions: [], withRef: false, cleanOnUnmount: true }, opts)

      if (!opts.key) {
        opts.key = 'NoKeyProvided'
      }

      opts.statekey = `${opts.key}.${uuidv4()}`
      opts.activeQueries = []

      class QueryWrapperInternal extends React.Component {
        ref = null

        getWrappedInstance () {
          return this.ref
        }

        componentWillUnmount () {
          if (opts.cleanOnUnmount) {
            store.dispatch(ClearValue(opts.statekey))
          }
          if (opts.activeQueries.length > 0) {
            _.each(opts.activeQueries, (a) => {
              a.cancel('Operation canceled by component unload.')
            })
          }
        }

        getQueryProps = _.once(() => {
          let ret = {}

          _.forEach(opts.actions, (a) => {
            if (ret[a.prop]) {
              throw new Error('action prop name already assigned!')
            }

            if (a.mapIsArray === true & _.isString(a.map) === true) {
              ret[`${a.map}UpdateArrayValue`] = (filterFunction, updateFunction, modifyFunction) => {
                store.dispatch(UpdateArrayValue(opts.statekey, a.map, filterFunction, updateFunction, modifyFunction))
              }
              ret[`${a.map}AppendArrayValue`] = (values) => {
                store.dispatch(AppendArrayValue(opts.statekey, a.map, values))
              }
            } else if (_.isString(a.map) === true) {
              ret[`${a.map}UpdateValue`] = (value) => {
                store.dispatch(SetValue(opts.statekey, a.map, value))
              }
            }

            ret[a.prop] = (data, loadMore = false) => {
              const currentStore = store.getState()
              store.dispatch(SetValue(opts.statekey, `loading${a.prop}`, true))

              let queryParams = _.merge({ Skip: 0 }, data)

              if (loadMore === true && (_.isString(a.map) || _.isFunction(a.map))) {
                queryParams.Skip = ((currentStore.AppState[opts.statekey] || {})[`${a.prop}SkipCount`] || 0) + 1
              }

              let lastCallCount = ((currentStore.AppState[opts.statekey] || {})[`${a.prop}CallCount`] || 0)

              const callCancel = CancelToken.source()
              callCancel.id = uuidv4()
              callCancel.propName = a.prop

              if (a.cancelPreviousCall === true) {
                for (let c of _.filter(opts.activeQueries, { propName: a.prop })) {
                  c.cancel('New call request made')
                }
              }

              opts.activeQueries.push(callCancel)

              const webCall = new Promise((resolve, reject) => {
                if (a.ignoreSessionTimer === true) {
                  console.log('ignoreSessionTimer')
                } else {
                  queryWrapperTimer.extendTimer()
                }

                axios({
                  url: a.url,
                  baseURL: process.env.API_URL,
                  data: queryParams,
                  crossDomain: true,
                  method: 'post',
                  headers: {
                    'token': Storage.Get(`MRxToken`) || ''
                  },
                  cancelToken: callCancel.token
                }).then(resp => {
                  // remove from active queries
                  opts.activeQueries = _.reject(opts.activeQueries, { id: callCancel.id })

                  if (resp.data.Status !== 'Success') {
                    _.each(resp.data.Messages, (m) => {
                      if (m.Type === 'Info') {
                        ShowInfo(m.Message)
                      } else if (m.Type === 'Warning') {
                        ShowWarning(m.Message)
                      } else if (m.Type === 'ModelFieldTypeError') {
                        log.Error('Model Field Type Error', { Error: m.Message })
                      } else if (m.Type === 'Rule') {
                        if (m.Field === '_error') {
                          ShowError(m.Message)
                        }
                      } else if (m.Type !== 'Rule') {
                        ShowError(m.Message)
                      }
                    })
                    store.dispatch(SetValue(opts.statekey, `loading${a.prop}`, false))
                    reject(resp.data.Messages)
                  } else {
                    // process only the info and warning messages if any
                    _.each(resp.data.Messages, (m) => {
                      if (m.Type === 'Info') {
                        ShowInfo(m.Message)
                      } else if (m.Type === 'Warning') {
                        ShowWarning(m.Message)
                      }
                    })

                    store.dispatch(SetValue(opts.statekey, `${a.prop}CallCount`, lastCallCount + 1))

                    if (_.isString(a.map)) {
                      if (queryParams.Skip > 0) {
                        store.dispatch(AppendArrayValue(opts.statekey, a.map, resp.data.ReturnValue))
                      } else {
                        store.dispatch(SetValue(opts.statekey, a.map, resp.data.ReturnValue))
                      }
                      if (a.mapIsArray === true) {
                        if (resp.data.ReturnValue.length === queryParams.Limit) {
                          store.dispatch(SetValue(opts.statekey, `${a.map}HasMore`, true))
                        } else {
                          store.dispatch(SetValue(opts.statekey, `${a.map}HasMore`, false))
                        }
                      }

                      store.dispatch(SetValue(opts.statekey, `loading${a.prop}`, false))
                      store.dispatch(SetValue(opts.statekey, `${a.prop}SkipCount`, queryParams.Skip))
                      resolve({ data: resp.data.ReturnValue, extra: resp.data.ExtraData })
                      return
                    }

                    if (_.isFunction(a.map)) {
                      let mapResult = a.map(resp.data.ReturnValue, queryParams.Skip)
                      if (!_.isEmpty(mapResult)) {
                        _.forEach(_.keys(mapResult), (k) => {
                          store.dispatch(SetValue(opts.statekey, k, mapResult[k]))
                        })
                      }
                      store.dispatch(SetValue(opts.statekey, `loading${a.prop}`, false))
                      store.dispatch(SetValue(opts.statekey, `${a.prop}SkipCount`, queryParams.Skip))
                      resolve({ data: resp.data.ReturnValue, extra: resp.data.ExtraData })
                      return
                    }

                    store.dispatch(SetValue(opts.statekey, `loading${a.prop}`, false))
                    resolve({ data: resp.data.ReturnValue, extra: resp.data.ExtraData })
                  }
                }).catch(err => {
                  // remove from active queries
                  opts.activeQueries = _.reject(opts.activeQueries, { id: callCancel.id })
                  log.Error('Ajax error', { Error: err })
                  if (err.response) {
                    const { status } = err.response
                    if (status === 401) {
                      store.dispatch(ClearSettings())
                      store.dispatch(ClearUser())
                      store.dispatch(CloseDrawer('all'))
                      store.dispatch(ClearAccount())
                      sendToURL(store.dispatch)('/Login')
                      ShowError('Invalid Authentication Token! Please login again.')
                      reject([{ Type: 'Authentication', Message: 'Invalid Authentication Token! Please login again.' }]) //eslint-disable-line
                    } else {
                      ShowError((err || {}).message || 'Unexpected Error :(')
                      reject(err)
                    }
                    store.dispatch(SetValue(opts.statekey, `loading${a.prop}`, false))
                  } else if (err.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log('error with request but no response', err)
                    ShowWarning('Network Error, Could not reach the backend server!')
                    store.dispatch(SetValue(opts.statekey, `loading${a.prop}`, false))
                  } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Other Error', err.message)
                    if (err.message !== 'New call request made') {
                      // don't change this if its a new call because the new call
                      // has already set this and will unset it later
                      store.dispatch(SetValue(opts.statekey, `loading${a.prop}`, false))
                    }
                  }
                })
              })
              webCall.cancel = (message) => {
                callCancel.cancel(message)
              }
              return webCall
            }
          })

          return ret
        })

        render () {
          const queryProps = this.getQueryProps()
          if (opts.withRef) {
            return (
              <WrappedComponent ref={(c) => { this.ref = c }} {...this.props} {...queryProps} AppStateKey={opts.key} />
            )
          } else {
            return (
              <WrappedComponent {...this.props} {...queryProps} AppStateKey={opts.statekey} />
            )
          }
        }
      }

      return compose(
        connect(
          buildState([
            sh.AppState([
              { sourceProp: opts.statekey, destProp: 'data', defaultValue: {} }
            ])
          ])
        )
      )(QueryWrapperInternal)
    }
  }

  if (_.isFunction(options)) {
    return queryWrapper({})(options)
  }

  return queryWrapper(options)
}
